// extracted by mini-css-extract-plugin
export default {"recoveryPassword":"styles_recoveryPassword__HD-Vh","button":"styles_button__4vorZ"};